import request from '@/utils/request'

/**
 * 获取当前 domain
 */
const getDomain = () => {
  return request({
    url: '/config',
    method: 'get',
    async: false,
    domain: 'NO_DOMAIN',
    noToken: true
  })
}

/**
 * 获取当前 LOGO参数
 */
const getLogo = (url) => {
  return request({
    url: url,
    method: 'get',
    async: false,
    domain: 'NO_DOMAIN',
    noToken: true
  })
}

export default {
  getDomain,
  getLogo
}



// WEBPACK FOOTER //
// ./src/api/domain.js